import { render, staticRenderFns } from "./noodKenC.vue?vue&type=template&id=62317eca&scoped=true"
import script from "./noodKenC.vue?vue&type=script&lang=js"
export * from "./noodKenC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62317eca",
  null
  
)

export default component.exports